import type { SVGProps } from 'react';
const SvgFollowTheSigns = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#follow_the_signs_svg__a)">
      <path
        fill="currentColor"
        d="M9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2ZM5.75 8.9 3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75ZM13 2v7h3.75v14h1.5V9H22V2h-9Zm5.01 6V6.25H14.5v-1.5h3.51V3l2.49 2.5L18.01 8Z"
      />
    </g>
    <defs>
      <clipPath id="follow_the_signs_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFollowTheSigns;
